<template>
    <BreadCrumb PageTitle="Liste des produits restreints" />
    <ListeProduitRestreint />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeProduitRestreint from "../../components/ProduitRestreint/ListeProduitRestreint.vue";

    export default defineComponent({
        name: "ListeProduitRestreintPage",
        components: {
            BreadCrumb,
            ListeProduitRestreint,
        },
    });
</script>